import { memo, SVGProps } from 'react'

function Tick(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36.999 37"
      width={props.width}
      height={props.height ?? props.width}
    >
      <path
        fill={props.fill}
        stroke="transparent"
        strokeMiterlimit="10"
        d="M18.5 36.5a18 18 0 1118-18 18.02 18.02 0 01-18 18zm-8.442-20.386A2.158 2.158 0 008.531 19.8l6.106 6.106a2.155 2.155 0 003.053 0L27.927 15.67a2.164 2.164 0 000-3.057 2.163 2.163 0 00-3.053 0l-8.71 8.711-4.581-4.577a2.138 2.138 0 00-1.525-.633z"
      />
    </svg>
  )
}

Tick.defaultProps = {
  width: 36,
  fill: '#006ba6'
}

export default memo(Tick)
